const arrayUnique = (arr) => [...new Set(arr)];

export default arrayUnique;
